module.exports = __webpack_public_path__ + "components/incentive/static/icon-check-c86517b399065149fd212f39254d51c0.svg";